<template>
    <div class="article-blog-survival">
        <p>
            The world of Registry Dance Events blew me away and continues to challenge me. There's so much to do in such
            a small space of time. And nobody tells you how to not only survive - but to thrive at these things!
        </p>
        <p>
            We have learnt a lot over the years for what works for us and the key is finding just that -
            <strong>what works for you</strong>.
        </p>
        <p>
            So here goes, this is just some of the things we think about before, during and after events. It might not
            work first time so it is trial and error and it will change depending on where you are in your dance journey
            or even what event you are at.
        </p>
        <p>
            <strong><u>Planning before</u></strong>
        </p>
        <ul>
            <li><p>How are you getting there - who else is going, can you car pool, share rooms etc.?</p></li>
            <li>
                <p>
                    Room with people who either have the same chaotic schedule you're planning (like social dancing till
                    6am) or have eye masks and earbuds.
                </p>
            </li>
            <li>
                <p>
                    If there is a time difference for the event - e.g. Budapest is 1 hour ahead to the UK - try to
                    arrive the day before to allow your body to adjust.
                </p>
            </li>
            <li><p>Know the check in times for your accommodation.</p></li>
            <li>
                <p>
                    Join any group chats your friends/dance school may have for the event (we tend to have a signal chat
                    for any we are going to).
                </p>
            </li>
            <li>
                <p>
                    Check out the schedule as soon as it is released and decide what you would like to do - highlight
                    stuff. The next point may be decided for you after this.
                </p>
            </li>
            <li>
                <p>
                    Pick 2 of the below to focus on, you can't go hard on everything that is happening. This may change
                    depending on the event/your progress within the dance.
                </p>
                <ol>
                    <li>
                        <p>
                            <strong>Workshops</strong> - is there a particular teacher you want to see/workshops which
                            fit what you are currently focusing on? Don't try and do them all or you will probably be
                            overwhelmed. Remember your regular dance coach can probably tell you what you need to be
                            focusing on and I can guarantee it won't be all of the 10 new things you have heard this
                            weekend.
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>Social Dancing </strong>- if this is your first event this could be overwhelming.
                            The dancers you know can be your support network - use them. Take a break if you need, step
                            outside if you get too hot. Don't feel like you HAVE to dance till breakfast, it may feel
                            like everyone is doing it but trust me they aren't. And for Follows - you absolutely can ask
                            for dances.
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>Socialising </strong>- room parties, going out for a group dinner - this stuff is
                            all just as important as the rest. It is a holiday, likely with your friends, after all.
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>Competitions </strong>- if these are important to you - make sure you have a
                            competition plan, know the timings, make sure you have registered in time and have your
                            number, plan time to get ready and be in the ballroom a little before for some practice.
                            Find some time to eat, these thing regularly overrun, so you have to be organised.
                        </p>
                    </li>
                </ol>
            </li>
            <li>
                <p>
                    Make sure you have the day after the event off work/have no plans - you will need to recharge. Maybe
                    plan to go to bed early so you can rest ready for the usual week to start again (as boring as it is
                    in comparison to dancing all weekend).
                </p>
            </li>
        </ul>
        <p>
            <strong><u>Packing</u></strong>
        </p>
        <ul>
            <li>
                <p>
                    At least 2 pairs of dance shoes - ideally ones you have already danced in so you know they don't
                    destroy your feet.
                </p>
            </li>
            <li>
                <p>Plan your outfits so you don't have to pack your entire wardrobe - you need at a minimum:</p>
                <ul>
                    <li><p>2 workshop outfits.</p></li>
                    <li><p>2 social dance outfits.</p></li>
                    <li>
                        <p>1 competition outfit if competing - what would be best for this is a whole other post...</p>
                    </li>
                    <li><p>1 smart/casual outfit - for dinner/drinks.</p></li>
                    <li><p>Comfies - for breakfast/lounging round the hotel/spa/gym.</p></li>
                </ul>
            </li>
            <li><p>Bring some home comforts that might help you settle - sleep mask/kindle.</p></li>
            <li><p>Bluetooth speaker - for the room parties/practice/chill time.</p></li>
            <li><p>Swim or gym gear - if there is a spa or a gym you would use, be prepared.</p></li>
            <li><p>Water Bottle - always stay hydrated and much better for the environment.</p></li>
        </ul>
        <p>
            <strong><u>Food</u></strong>
        </p>
        <ul>
            <li>
                <p>
                    Either pack food to bring with you or make sure you know where the nearest supermarket is when you
                    get there.
                </p>
            </li>
            <li>
                <p>
                    Vitamins/supplements - you are wearing down your body so make sure you replenish it.
                    <a href="https://uk.huel.com/" target="_blank" rel="noopener noreferrer nofollow">Huel</a> has been
                    a game changer for us because it's amazing the amount you end up missing meals!
                </p>
            </li>
            <li><p>Healthy snacks - apples/bananas, fruit in general/nuts.</p></li>
            <li>
                <p>Tea - probably provided if you are staying in a hotel but warning it might not be Yorkshire Tea!</p>
            </li>
            <li>
                <p>
                    Plan meals where possible. Are you going to go to breakfast in the hotel? If not I like to take
                    porridge pots which just need boiling water and some banana and nuts to put in it.
                </p>
            </li>
            <li>
                <p>
                    Check out the hotel restaurant - do they have food you like, are they slow service - this needs
                    taking into account if you are wanting to eat at a certain time before competitions. The hotel food
                    service usually grinds to a halt at these events. We've been so hungry for competitions before, that
                    we were nearly at the point of fainting. Again, having Huel on hand is perfect for when things get
                    really tight on timings.
                </p>
            </li>
            <li><p>What restaurants or takeaways are there in the area?</p></li>
            <li><p>Protein bars.</p></li>
            <li><p>Electrolytes.</p></li>
            <li><p>Food that can be made with hot water - pot noodles.</p></li>
            <li>
                <p>
                    Alcohol - if you are planning on drinking even if just a little its a lot cheaper to bring this with
                    you.
                </p>
            </li>
        </ul>
        <p>
            At least one large, protein and veggie-rich lunch or dinner per day makes a world of difference even if you
            snack the rest of the day!
        </p>
        <p>
            <strong><u>Planning there</u></strong>
        </p>
        <p>
            You already have your highlighted schedule (if not do it now) and know which are your priorities for the
            weekend - its a case of then fitting in the rest including time for self care:
        </p>
        <ul>
            <li>
                <p>
                    Naps - if you can (you lucky people) then plan them in. For example if you aren't competing, nap in
                    this time ready for social dancing.
                </p>
            </li>
            <li>
                <p>
                    Sleep schedule - try and work out how much sleep you need each day to be able to still function and
                    use this to decide when you are calling it a night and when you are starting the day - maybe you
                    skip breakfast and the first workshop, or maybe you stop social dancing a little earlier.
                </p>
            </li>
            <li>
                <p>
                    Boundaries - set the boundaries that are possible within whatever limitations you have. Accept those
                    boundaries for yourself, as well as for others. Do what you need to do to take care of you.
                </p>
            </li>
            <li>
                <p>
                    Accept that your priorities may change if exciting opportunities crop up - it might be more
                    beneficial to join that room party of dancers you have never met before rather than get an early
                    night for workshops in the morning.
                </p>
            </li>
            <li>
                <p>
                    If you feel yourself starting to burnout, take the time to recoup early. There is always another
                    dance event so do what your body and mind allows.
                </p>
            </li>
            <li>
                <p>
                    On arrival set up base camp however works for you - get clothes out and hang them up (especially
                    maybe shirts), get food or drinks in the fridge if there is one.
                </p>
            </li>
            <li><p>Stretching - before any dancing and especially at the end of the night.</p></li>
            <li>
                <p>
                    Alcohol - I would prioritise between dancing and drinking. You might think you are brilliant dancing
                    after a few too many drinks but maybe your partner doesn't - we have a duty to protect not only
                    ourselves but also those who we are dancing with and those around us. That said if just 1 drink for
                    Dutch courage helps get you on the dance floor go for it.
                </p>
            </li>
            <li>
                <p>
                    Take some time to get outside - if not you can spend an entire weekend not leaving the hotel. If you
                    have gone somewhere outside of your home town its always good to do some sightseeing.
                </p>
            </li>
            <li>
                <p>
                    Spa time? Bath time? All good for recovery both mentally and physically. Epsom salts to soak aching
                    limbs.
                </p>
            </li>
            <li>
                <p>
                    Know your checkout times so you can get enough sleep ready for the next day if maybe you have a long
                    drive and so you know when to pack.
                </p>
            </li>
            <li>
                <p>
                    There is usually a live stream -- hook this up in your room so you can always see what's going on.
                    Trust me the timings of anything other than workshops is more of a guideline so if you want to see
                    the All Stars comp you don't have to stay in the ballroom for all the competitions waiting for it.
                </p>
            </li>
        </ul>
        <p>
            <strong><u>The Aftermath</u></strong>
        </p>
        <p>
            Even if you did everything you could for self care you will probably be shattered - make sure you rest. You
            will however also be on a huge dance high and the come down is not so fun - sat back at your desk at work
            wishing you were dancing instead. That's when you get the next one booked in :)
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleBlogSurvival',
};
</script>
